import { AmbassadorError, DispatchEmptyObject, DispatchObject, Paginator } from '@/models/globalModels';
import { BadgeItemType, LoyaltyTask, LoyaltyTier, PointSystemInfo } from '@/models/loyaltyModels';
import ApiService from '@/services/ApiService';
import LocalDataService from '@/services/LocalDataService';

import { getProfileData } from '../../auth/actions';
import * as t from '../types';

export const doGetLoyaltyBadges = () => (dispatch: any) => {
  dispatch(doBadgesFetching());
  const token = LocalDataService.getAuth();
  ApiService.setToken(token);
  ApiService.getLoyaltyBadges(LocalDataService.getCompanyId())
    .then((badges) => {
      dispatch(doBadgesFetch(badges));
    })
    .catch((e) => dispatch(doBadgesFetchError(e)));
};

export const doGetLoyaltyTiers = () => (dispatch: any) => {
  dispatch(doTiersFetching());
  const token = LocalDataService.getAuth();
  ApiService.setToken(token);
  ApiService.getLoyaltyTiers(LocalDataService.getCompanyId())
    .then((tiers) => {
      dispatch(doTiersFetch(tiers));
    })
    .catch((e) => dispatch(doTiersFetchError(e)));
};

// REDUX updates //
export const doSetLoyaltyPoints = (points: PointSystemInfo) => (dispatch: DispatchObject<PointSystemInfo>) => {
  dispatch({
    type: t.SET_LOYALTY_POINTS,
    payload: points,
  });
};

export const doBadgesFetching = () => (dispatch: DispatchEmptyObject) => {
  dispatch({
    type: t.LOYALTY_BADGES_FETCHING,
  });
};

export const doBadgesFetch = (badges: Paginator<BadgeItemType>) => (dispatch: DispatchObject<Paginator<BadgeItemType>>) => {
  dispatch({
    type: t.LOYALTY_BADGES_FETCH,
    payload: badges,
  });
};

export const doTiersFetchError = (error: AmbassadorError) => (dispatch: DispatchObject<AmbassadorError>) => {
  dispatch({
    type: t.LOYALTY_TIERS_FETCH_ERROR,
    payload: { ...error },
  });
};

export const doTiersFetching = () => (dispatch: DispatchEmptyObject) => {
  dispatch({
    type: t.LOYALTY_TIERS_FETCHING,
  });
};

export const doTiersFetch = (tiers: Paginator<LoyaltyTier>) => (dispatch: DispatchObject<Paginator<LoyaltyTier>>) => {
  dispatch({
    type: t.LOYALTY_TIERS_FETCH,
    payload: tiers,
  });
};

export const doBadgesFetchError = (error: AmbassadorError) => (dispatch: DispatchObject<AmbassadorError>) => {
  dispatch({
    type: t.LOYALTY_BADGES_FETCH_ERROR,
    payload: { ...error },
  });
};

export const doGetLoyaltyTasks = () => (dispatch: any) => {
  dispatch(doTasksFetching());
  const token = LocalDataService.getAuth();
  ApiService.setToken(token);
  ApiService.getLoyaltyTasks(LocalDataService.getCompanyId())
    .then((tasks) => {
      dispatch(doTasksFetch(tasks));
    })
    .catch((e) => dispatch(doTasksFetchError(e)));
};

export const doTasksFetching = () => (dispatch: DispatchEmptyObject) => {
  dispatch({
    type: t.LOYALTY_TASKS_FETCHING,
  });
};

export const doTasksFetch = (tasks: Paginator<LoyaltyTask>) => (dispatch: DispatchObject<Paginator<LoyaltyTask>>) => {
  dispatch({
    type: t.LOYALTY_TASKS_FETCH,
    payload: tasks,
  });
};

export const doTasksFetchError = (error: AmbassadorError) => (dispatch: DispatchObject<AmbassadorError>) => {
  dispatch({
    type: t.LOYALTY_TASKS_FETCH_ERROR,
    payload: { ...error },
  });
};

export const doSendTaskClickLoyaltyData = (taskId: string) => async (dispatch: DispatchObject<any>) => {
  const token = LocalDataService.getAuth();
  const userId = LocalDataService.getUid();
  ApiService.setToken(token);
  await ApiService.postLoyaltyData(userId, { 'affiliate.loyalty_clickable_tasks': taskId });
  await getProfileData()(dispatch);
};
